import { useEffect, useState } from "react";
import { FaChevronLeft } from "react-icons/fa";
import axios from "axios";
import { GetRides } from "../../Services";
import { useNavigate } from "react-router-dom";

const PendingRides = () => {
  const navigate = useNavigate();
  const [rides, setRides] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  // useEffect(() => {
  //   const fetchDocuments = async () => {
  //     try {
  //       const response = await axios.get(
  //         `https://binberu.idaprocharity.com/api/v1/admin/get-ride-by-status/CANCELED`
  //       );
  //       console.log("API Response: ", response.data); // Log the response

  //       // Access the rides array from the response
  //       const fetchedRides = response.data.data || []; // Ensure it's an array
  //       setRides(fetchedRides);
  //     } catch (error) {
  //       console.error("Error fetching documents:", error);
  //       setRides([]); // Set to empty array on error
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchDocuments();
  // }, []);

  useEffect(() => {
    const fetchCanceledRides = async () => {
      setLoading(true);
      try {
        const data = await GetRides.fetchRidesByStatus(`COMPLETE`);
        setRides(Array.isArray(data.data) ? data.data : []);

        // console.log("Vehicles", data);
      } catch (error) {
        console.error("Error fetching dispatcher:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchCanceledRides();
  }, []);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
          <h2 className="text-2xl font-bold">Completed Rides</h2>
        </div>

        <div className="card">
          <div className="card-header">
            <button
              type="button"
              className="btn btn-outline-secondary ml-2"
              onClick={() => navigate("/rides")} // Navigate to /all-rides
            >
              <FaChevronLeft className="mr-1" /> Back
            </button>
          </div>
          <div className="card-body flex flex-col">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <div className="d-flex gap-4">
                <button type="button" className="btn btn-outline-secondary">
                  CSV
                </button>
                <button
                  type="button"
                  className="btn btn-outline-secondary ml-2"
                >
                  Excel
                </button>
                <button
                  type="button"
                  className="btn btn-outline-secondary ml-2"
                >
                  PDF
                </button>
              </div>

              <input
                type="text"
                className="form-control"
                placeholder="Search..."
                style={{ width: "300px" }}
              />
            </div>

            <div className="mt-4">
              {loading ? (
                <div className="">
                  <p>Loading ride history...</p>
                  <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              ) : rides.length === 0 ? (
                <div className="">
                  <p>No rides found for this status.</p>
                </div>
              ) : (
                <table className="table table-bordered w-full">
                  <thead>
                    <tr>
                      <th>Ride ID</th>
                      <th>Driver Name</th>
                      <th>Pickup Date</th>
                      <th>Drop Time</th>
                      <th>Pickup Point</th>
                      <th>Drop Point</th>
                      <th>Distance</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rides.map((ride) => (
                      <tr key={ride.id}>
                        <td>{ride.id}</td>
                        <td>{ride.driverId}</td>
                        <td>{ride.createdAt}</td>
                        <td>{ride.updatedAt}</td>
                        <td>{ride.currentLocationName}</td>
                        <td>{ride.destinationLocationName}</td>
                        <td>{ride.distance}</td>
                        <td>
                          <span
                            style={{
                              color: (() => {
                                switch (ride.status) {
                                  case "PENDING":
                                    return "orange";
                                  case "COMPLETE":
                                    return "green";
                                  case "CANCELED":
                                    return "red";
                                  default:
                                    return "gray";
                                }
                              })(),
                              backgroundColor: (() => {
                                switch (ride.status) {
                                  case "PENDING":
                                    return "#fff3cd"; // Light yellow for pending
                                  case "COMPLETE":
                                    return "#d4edda"; // Light green for complete
                                  case "CANCELED":
                                    return "#f8d7da"; // Light red for canceled
                                  default:
                                    return "#e9ecef"; // Light gray for unknown
                                }
                              })(),
                              padding: "2px 5px",
                              borderRadius: "4px",
                            }}
                          >
                            {ride.status.charAt(0).toUpperCase() +
                              ride.status.slice(1).toLowerCase()}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>

            <div className="card-footer clearfix">
              <ul className="pagination pagination-sm m-0 float-right">
                <li className="page-item">
                  <a
                    className="page-link"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      if (currentPage > 1) handlePageChange(currentPage - 1);
                    }}
                  >
                    &laquo;
                  </a>
                </li>
                {[...Array(totalPages).keys()].map((page) => (
                  <li
                    className={`page-item ${
                      currentPage === page + 1 ? "active" : ""
                    }`}
                    key={page + 1}
                  >
                    <a
                      className="page-link"
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        handlePageChange(page + 1);
                      }}
                    >
                      {page + 1}
                    </a>
                  </li>
                ))}
                <li className="page-item">
                  <a
                    className="page-link"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      if (currentPage < totalPages)
                        handlePageChange(currentPage + 1);
                    }}
                  >
                    &raquo;
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PendingRides;
